import { differenceInCalendarDays, format } from 'date-fns';

const useMessageTimestamp = (date: Date | null) => {
  if (!date) {
    return null;
  }
  const daysDiff = differenceInCalendarDays(Date.now(), date);

  if (daysDiff < 1) {
    return `Today at ${format(date, 'HH:mm')}`;
  }

  if (daysDiff === 1) {
    return `Yesterday at ${format(date, 'HH:mm')}`;
  }

  return `${format(date, 'MMMM dd, yyyy')} at ${format(date, 'HH:mm')}`;
};

export default useMessageTimestamp;
